<template>
	<div class="FieldText">
		<BaseTextArea
			v-model="field.value"
			:label="field.label"
			:min="field.min"
			:max="field.max"
			:unit="field.unit"
			inline>
		</BaseTextArea>
	</div>
</template>

<script>
	export default {
		props: {
			field: Object
		}
	}
</script>